module.exports = __webpack_public_path__ + "img/btn_menu_prefecture.86951df4.png";